var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 3.06311C20.0523 3.06311 20.5 2.61539 20.5 2.06311V1.93652C20.5 1.38424 20.0523 0.936523 19.5 0.936523H1.5C0.947715 0.936523 0.5 1.38424 0.5 1.93652V2.06311C0.5 2.61539 0.947715 3.06311 1.5 3.06311H19.5ZM19.5 5.18969C20.0523 5.18969 20.5 5.6374 20.5 6.18969V6.31627C20.5 6.86856 20.0523 7.31627 19.5 7.31627H7.5C6.94772 7.31627 6.5 6.86856 6.5 6.31627V6.18969C6.5 5.6374 6.94772 5.18969 7.5 5.18969H19.5ZM19.5 11.5694C20.0523 11.5694 20.5 11.1217 20.5 10.5694V10.4429C20.5 9.89057 20.0523 9.44285 19.5 9.44285H1.5C0.947715 9.44285 0.5 9.89057 0.5 10.4429V10.5694C0.5 11.1217 0.947715 11.5694 1.5 11.5694H19.5ZM19.5 15.8226C20.0523 15.8226 20.5 15.3749 20.5 14.8226V14.696C20.5 14.1437 20.0523 13.696 19.5 13.696H7.5C6.94772 13.696 6.5 14.1437 6.5 14.696V14.8226C6.5 15.3749 6.94772 15.8226 7.5 15.8226H19.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.1b117d18560fe9f7c5482d8777ebc412.svg";
export { ForwardRef as ReactComponent };